<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content pt-0">
    <div class="container">
        <div class="col-12 pl-0">
            <div class="crumbs breadcrumbs-style-2">
                <ul class="breadcrumb">
                    <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                    </li>
                    <li class="mt-3" *ngIf="role === 'adm' || role ==='asst'">
                        <a routerLink="/customers/show;cs=all">Clients</a>
                    </li>
                    <li class="mt-3" *ngIf="role === 'cmrc'">
                        <a routerLink="/my-customers/show;cs=all">Mes Clients</a>
                    </li>
                    <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Objectifs</a></li>
                </ul>
            </div>
        </div>
        <div class="page-header">
            <div class="page-title">
                <h2 *ngIf="role=='adm' || role=='asst'">
                    <i class="flaticon-dollar-coin text-success"></i><b> Objectifs - Clients </b></h2>
            </div>
        </div>
        <div class="accordion" id="accordionExample" style="background: none;">
            
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing" > 
                    <div class="widget-content widget-content-area">
                        <div class="form-group row col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-0">
                            <label for="yearsSelect" class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-sm">
                                Mois :
                            </label>
                            <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 pr-0 pl-0">
                                <select [(ngModel)]="selectedMonth" id="yearsSelect" 
                                    class="form-control-rounded form-control col-lg-6 col-md-6 col-sm-6"
                                    (ngModelChange)="onMonthChange($event)">
                                    <option *ngFor="let month of months" 
                                            [value]="month.value" 
                                            [selected]="month.selected">
                                        {{month.text}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div class="basic_ribbon br-4 mt-0">
                                    <h6 class="pb-0">Urgent - CA Critique 
                                        <span class="badge badge-danger ml-2">{{ criticalPagination?.totalElements || 0 }}</span>
                                        <br>
                                        <span class="m-0">(CA Réalisé < 75% CA Objectif) </span>
                                    </h6>
                                    <form class="mx-auto" (ngSubmit)="onSearch('critical')">
                                        <div class="form-group form-group-search">
                                            <label for="searchInput" class="sr-only">Recherche</label>
                                            <input type="text" class="form-control" id="searchInput" placeholder="Rechercher par raison sociale, commercial..."
                                                [(ngModel)]="searchCriticalTerm" name="searchCritical" (input)="filterClients('critical')">
                                        </div>
                                    </form>
                                    
                                    <!-- Loader -->
                                    <div *ngIf="loading_customers_goals" class="cp-spinner cp-round loader_classifications"></div>
                                    
                                    <!-- Contenu -->
                                    <div *ngIf="!loading_customers_goals">
                                        <!-- Message aucun résultat -->
                                        <div *ngIf="filteredCriticalCustomers.length === 0 && searchCriticalTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé pour "{{searchCriticalTerm}}"</p>
                                        </div>
                                        <div *ngIf="filteredCriticalCustomers.length === 0 && !searchCriticalTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé</p>
                                        </div>
                                        
                                        <!-- Liste des clients -->
                                        <div class="client-card p-3" *ngFor="let client of filteredCriticalCustomers; let index=index">
                                            <div class="client-header mb-0">
                                                <div class="client-info">
                                                    <p class="cust-rs mb-0">{{client.name}}</p>
                                                    <p class="last-visit">Dernière visite le : {{client.lastVisit}}</p>
                                                </div>
                                                <div class="avatar-wrapper">
                                                    <img *ngIf="client.commercialName!=null && client.avatar != null" 
                                                        [src]="'data:image/jpeg;base64,' + client.avatar" 
                                                        alt="{{client.name}}" 
                                                        title="{{client.commercialName}}"
                                                        class="client-avatar"
                                                        (click)="toggleTooltip(client)">
                                                    <img *ngIf="client.commercialName!=null && client.avatar==null" 
                                                        src="../../assets/img/unknown_user.jpg" 
                                                        alt="{{client.name}}" 
                                                        title="{{client.commercialName}}"
                                                        class="client-avatar"
                                                        (click)="toggleTooltip(client)">
                                                    <span class="tooltip" *ngIf="activeTooltipId === client.name">
                                                        {{client.commercialName}}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div class="stats-container">
                                                <div class="stat-box">
                                                    <div class="stat-label">Objectif</div>
                                                    <div class="stat-value">{{client.objective | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="stat-box">
                                                    <div class="stat-label">Réalisé</div>
                                                    <div class="stat-value achieved">{{client.achieved | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="chart-container">
                                                    <canvas id="chart{{index}}" class="recup-chart"></canvas>
                                                </div>
                                            </div>
                                            <button class="create-visit-btn" data-toggle="modal" (click)="getCustomer(client)" data-target="#newsModal"
                                                *ngIf="role === 'adm' || role ==='asst'">
                                                Créer une visite
                                            </button>
                                        </div>
                                        
                                        <!-- BOUTON CHARGER LA SUITE -->
                                        <div *ngIf="criticalPagination?.hasMore && !searchCriticalTerm" class="load-more-container text-center mt-3 mb-2">
                                            <a href="javascript:void(0)"
                                                (click)="loadMoreCritical()">
                                                <span *ngIf="!loading_more_critical" class="more_link">
                                                    <i class="fa fa-plus-circle mr-1"></i> Charger la suite
                                                </span>
                                                <span *ngIf="loading_more_critical" class="more_link">
                                                    <i class="fa fa-spinner fa-spin mr-1"></i> Chargement...
                                                </span>
                                            </a>
                                            <p class="pagination-info-text mt-2 mb-0">
                                                <small class="text-muted">
                                                    Affichage de <strong>{{filteredCriticalCustomers.length}}</strong> sur <strong>{{criticalPagination.totalElements}}</strong>
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>    
                            </div>

                            <!-- ========== COLONNE CLIENTS À AMÉLIORER ========== -->
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div class="basic_ribbon br-4 mt-0">
                                    <h5 class="pb-0">Attention - CA à Améliorer
                                        <span class="badge badge-warning ml-2">{{ warningPagination?.totalElements || 0 }}</span>
                                        <br>
                                        <span class="m-0">(75% < CA Réalisé < 100% CA Objectif) </span>
                                    </h5>
                                    <form class="mx-auto" (ngSubmit)="onSearch('warning')">
                                        <div class="form-group form-group-search">
                                            <label for="searchInput" class="sr-only">Recherche</label>
                                            <input type="text" class="form-control" id="searchInput" placeholder="Rechercher par raison sociale, commercial..."
                                                [(ngModel)]="searchWarningTerm" name="searchWarning" (input)="filterClients('warning')">
                                        </div>
                                    </form>
                                    
                                    <!-- Loader -->
                                    <div *ngIf="loading_customers_goals" class="cp-spinner cp-round loader_classifications"></div>
                                    
                                    <!-- Contenu -->
                                    <div *ngIf="!loading_customers_goals">
                                        <!-- Message aucun résultat -->
                                        <div *ngIf="filteredWarningCustomers.length === 0 && searchWarningTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé pour "{{searchWarningTerm}}"</p>
                                        </div>
                                        <div *ngIf="filteredWarningCustomers.length === 0 && !searchWarningTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé</p>
                                        </div>
                                        
                                        <!-- Liste des clients -->
                                        <div class="client-card p-3 client-warning-card" *ngFor="let client of filteredWarningCustomers; let index=index">
                                            <div class="client-header mb-0">
                                                <div class="client-info">
                                                    <p class="cust-rs mb-0">{{client.name}}</p>
                                                    <p class="last-visit text-warning">Dernière visite le : {{client.lastVisit}}</p>
                                                </div>
                                                <div class="avatar-wrapper">
                                                    <img *ngIf="client.commercialName!=null && client.avatar != null" 
                                                        [src]="'data:image/jpeg;base64,' + client.avatar" 
                                                        alt="{{client.name}}" 
                                                        class="client-avatar"
                                                        title="{{client.commercialName}}"
                                                        (click)="toggleTooltip(client)">
                                                    <img *ngIf="client.commercialName!=null && client.avatar==null" 
                                                        src="../../assets/img/unknown_user.jpg" 
                                                        alt="{{client.name}}" 
                                                        class="client-avatar"
                                                        title="{{client.commercialName}}"
                                                        (click)="toggleTooltip(client)">
                                                    <span class="tooltip" *ngIf="activeTooltipId === client.name">
                                                        {{client.commercialName}}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div class="stats-container">
                                                <div class="stat-box">
                                                    <div class="stat-label">Objectif</div>
                                                    <div class="stat-value">{{client.objective | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="stat-box">
                                                    <div class="stat-label">Réalisé</div>
                                                    <div class="stat-value achieved text-warning">{{client.achieved | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="chart-container">
                                                    <canvas id="chartwarn{{index}}" class="recup-chart"></canvas>
                                                </div>
                                            </div>
                                            <button class="create-visit-btn" data-toggle="modal" (click)="getCustomer(client)" data-target="#newsModal"
                                                *ngIf="role === 'adm' || role ==='asst'">
                                                Créer une visite
                                            </button>
                                        </div>
                                        
                                        <!-- BOUTON CHARGER LA SUITE -->
                                        <div *ngIf="warningPagination?.hasMore && !searchWarningTerm" class="load-more-container text-center mt-3 mb-2">
                                            <a href="javascript:void(0)" 
                                                (click)="loadMoreWarning()">
                                                <span *ngIf="!loading_more_warning" class="more_link">
                                                    <i class="fa fa-plus-circle mr-1"></i> Charger la suite
                                                </span>
                                                <span *ngIf="loading_more_warning" class="more_link">
                                                    <i class="fa fa-spinner fa-spin mr-1"></i> Chargement...
                                                </span>
                                            </a>
                                            <p class="pagination-info-text mt-2 mb-0">
                                                <small class="text-muted">
                                                    Affichage de <strong>{{filteredWarningCustomers.length}}</strong> sur <strong>{{warningPagination.totalElements}}</strong>
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>    
                            </div>

                            <!-- ========== COLONNE OBJECTIF ATTEINT ========== -->
                            <div class="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div class="basic_ribbon br-4 mt-0">
                                    <h2 class="pb-0">Objectif Atteint
                                        <span class="badge badge-success ml-2">{{ successPagination?.totalElements || 0 }}</span>
                                        <br>
                                        <span class="m-0">(CA Réalisé >= 100% CA Objectif) </span>
                                    </h2>
                                    <form class="mx-auto" (ngSubmit)="onSearch('success')">
                                        <div class="form-group form-group-search">
                                            <label for="searchInput" class="sr-only">Recherche</label>
                                            <input type="text" class="form-control" id="searchInput" placeholder="Rechercher par raison sociale, commercial..."
                                                [(ngModel)]="searchSuccessTerm" name="searchSuccess" (input)="filterClients('success')">
                                        </div>
                                    </form>
                                    
                                    <!-- Loader -->
                                    <div *ngIf="loading_customers_goals" class="cp-spinner cp-round loader_classifications"></div>
                                    
                                    <!-- Contenu -->
                                    <div *ngIf="!loading_customers_goals">
                                        <!-- Message aucun résultat -->
                                        <div *ngIf="filteredSuccessCustomers.length === 0 && searchSuccessTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé pour "{{searchSuccessTerm}}"</p>
                                        </div>
                                        <div *ngIf="filteredSuccessCustomers.length === 0 && !searchSuccessTerm" class="no-results text-center p-4">
                                            <p>Aucun client trouvé</p>
                                        </div>
                                        
                                        <!-- Liste des clients -->
                                        <div class="client-card p-3 client-success-card" *ngFor="let client of filteredSuccessCustomers; let index=index">
                                            <div class="client-header mb-0">
                                                <div class="client-info">
                                                    <p class="cust-rs mb-0">{{client.name}}</p>
                                                    <p class="last-visit text-success">Dernière visite le : {{client.lastVisit}}</p>
                                                </div>
                                                <div class="avatar-wrapper">
                                                    <img *ngIf="client.commercialName!=null && client.avatar != null" 
                                                        [src]="'data:image/jpeg;base64,' + client.avatar" 
                                                        alt="{{client.name}}" 
                                                        class="client-avatar"
                                                        title="{{client.commercialName}}"
                                                        (click)="toggleTooltip(client)">
                                                    <img *ngIf="client.commercialName!=null && client.avatar==null" 
                                                        src="../../assets/img/unknown_user.jpg" 
                                                        alt="{{client.name}}" 
                                                        class="client-avatar"
                                                        title="{{client.commercialName}}"
                                                        (click)="toggleTooltip(client)">
                                                    <span class="tooltip" *ngIf="activeTooltipId === client.name">
                                                        {{client.commercialName}}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div class="stats-container">
                                                <div class="stat-box">
                                                    <div class="stat-label">Objectif</div>
                                                    <div class="stat-value">{{client.objective | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="stat-box">
                                                    <div class="stat-label">Réalisé</div>
                                                    <div class="stat-value achieved text-success">{{client.achieved | number:'1.2-2'}} MAD HT</div>
                                                </div>
                                                <div class="chart-container">
                                                    <canvas id="chartsuccess{{index}}" class="recup-chart"></canvas>
                                                </div>
                                            </div>
                                            <!-- Bouton optionnel pour succès -->
                                            <!-- <button class="create-visit-btn">
                                                Créer une visite
                                            </button> -->
                                        </div>
                                        
                                        <!-- BOUTON CHARGER LA SUITE -->
                                        <div *ngIf="successPagination?.hasMore && !searchSuccessTerm" class="load-more-container text-center mt-3 mb-2">
                                            <a href="javascript:void(0)" 
                                                (click)="loadMoreSuccess()">
                                                <span *ngIf="!loading_more_success" class="more_link">
                                                    <i class="fa fa-plus-circle mr-1"></i> Charger la suite
                                                </span>
                                                <span *ngIf="loading_more_success" class="more_link">
                                                    <i class="fa fa-spinner fa-spin mr-1"></i> Chargement...
                                                </span>
                                            </a>
                                            <p class="pagination-info-text mt-2 mb-0">
                                                <small class="text-muted">
                                                    Affichage de <strong>{{filteredSuccessCustomers.length}}</strong> sur <strong>{{successPagination.totalElements}}</strong>
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="newsModal" class="modal animated fadeInUp custo-fadeInUp newsmoddal" role="dialog">
    <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"><i class="flaticon-car-1 mr-2" style="font-size: x-large;"></i> 
                    <b>Nouvelle visite à faire : {{selectedCustomerToVisit?.name}}</b></h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <form id="visit_form" [formGroup]="newVisitForm" class="mb-3">
                        <div class=" col-lg-12 col-md-12">
                            <div class="col-lg-12 col-md-12 pr-0 pl-0">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 right_inputs">
                                    <label class="mt-1 col-lg-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm">
                                        Affecté à : 
                                        <span *ngIf="selectedCustomerToVisit?.commercialName==null"style="color: red;"><b>*</b></span>
                                    </label>
                                    <div class="col-lg-7 col-lg-7 col-md-7 col-sm-12 col-12 pr-0 pl-0"> 
                                        <!-- <h5 class="mt-2" *ngIf="selectedCustomerToVisit?.commercialName!=null"> 
                                            <img *ngIf="selectedCustomerToVisit.commercialName!=null && selectedCustomerToVisit.avatar != null" 
                                                [src]="'data:image/jpeg;base64,' +selectedCustomerToVisit.avatar" 
                                                alt="{{selectedCustomerToVisit.name}}" 
                                                title="{{selectedCustomerToVisit.commercialName}}" 
                                                class="client-avatar">
                                            <img *ngIf="selectedCustomerToVisit.commercialName!=null && selectedCustomerToVisit.avatar==null" 
                                                title="{{selectedCustomerToVisit.commercialName}}" 
                                                src="../../assets/img/unknown_user.jpg" 
                                                alt="{{selectedCustomerToVisit.name}}" 
                                                class="client-avatar"> 
                                            {{selectedCustomerToVisit?.commercialName}}</h5> -->
                                        <select class="form-control-rounded form-control" formControlName="commercial" name="commercial" id="commercial"
                                            >
                                            <option value="">Sélectionner le commercial</option>
                                            <option *ngFor="let commercial of commercials" [value]="commercial.commercial_uuid">{{commercial.commercial}}</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- MF-1881 — champ Sujets, absent de cet écran jusqu'ici : les visites créées
                                     depuis les objectifs de CA n'en portaient aucun. Même saisie que les actions
                                     juste en dessous : liste déroulante simple, puis un badge par sujet. -->
                                <div class="form-group mb-3 row col-lg-12 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <label for="topicsToSelect" class=" mt-1 col-lg-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 
                                    col-form-label col-form-label-sm">Visit topics <span style="color: red;"><b>*</b></span></label>
                                    <div class="col-lg-7 col-lg-7 col-md-7 col-sm-12 col-12 pr-0 pl-0">
                                        <select class="form-control-rounded form-control mb-2" id="topicsToSelect"
                                            (change)="addSelectedTopic($event)" [disabled]="topicsLimitReached()">
                                            <option value="">Sélectionner le topic</option>
                                            <option *ngFor="let topic of topics" [value]="topic.uuid">{{topic.topic}}</option>
                                        </select>
                                        <small class="form-text text-muted">
                                            {{ selectedTopicsCount() }} / {{ maxTopics }} sujet(s) sélectionné(s)
                                        </small>
                                    </div>
                                    <div class="topics-badges col-12 pl-0 pr-0" id="selectedtopics">
                                        <p *ngIf="topicsSelected.length==0" id="noTopicsSelected" class="no-topic">
                                            Aucun sujet n'est sélectionné</p>
                                        <span class="badge-chip badge-success t-secondary topic-chip" *ngFor="let topic of topicsSelected">
                                            <span class="text">{{topic.topic}}</span>
                                            <span class="closebtn" (click)="removeSelectedTopic(topic)">&times;</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group mb-3 row col-lg-12 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <label for="sectorsSelect" class=" mt-1 col-lg-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 
                                    col-form-label col-form-label-sm">Actions <span style="color: red;"><b>*</b></span></label>
                                    <div class="col-lg-7 col-lg-7 col-md-7 col-sm-12 col-12 pr-0 pl-0">
                                        <select class="form-control-rounded form-control mb-2" id="actionsToSelect">
                                            <option value="">Sélectionner Actions</option>
                                            <option *ngFor="let action of customizedActions" [value]="action.action_uuid"
                                                tp="c" [attr.ud]="action.action_uuid">{{action.action_label}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group mb-4 row col-lg-12 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <label for="sectorsSelect" class="col-lg-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm">Nouvelle action ? 
                                        <span style="color: red;"><b>*</b></span></label>
                                    <div class="row col-lg-7 col-md-7 col-sm-12 col-12 pr-0 pl-0"> 
                                        <div class="col-lg-11 col-md-11 col-sm-12">
                                            <input value="" placeholder="Saisir l'action" name="action_description"
                                            type="text" class="form-control-rounded form-control" formControlName="action_description">
                                        <div *ngIf="newVisitForm.get('action_description')?.errors?.required"  class="invalid-feedback"> 
                                            L'action est obligatoire</div> 
                                        </div>
                                            <div id="click2" style="font-size: larger;cursor: pointer;">
                                            <i class="fas fa-plus" (click)="newAction()"></i>
                                        </div>
                                    </div>
                                </div>
                                <!-- MF-1881 — même présentation compacte que les badges des sujets. -->
                                <div class="topics-badges" id="selectedactions">
                                    <span *ngIf="actionNotAssigned && actionsSelected.length==0" style="color: red;" class="flaticon-warning mr-2"></span>
                                    <p *ngIf="actionsSelected.length==0" id="noActionsSelected" class="no-topic">
                                        Aucune action n'est affectée</p>
                                    <span class="badge-chip badge-success t-secondary topic-chip" *ngFor="let action of actionsSelected">
                                        <span class="text">{{action.action_description}}</span>
                                        <span class="closebtn" (click)="removeSelectedAction(actionsSelected,action)">&times;</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                </form>
                <div *ngIf="loadingSaveVisit" class="cp-spinner cp-bubble" style="margin: auto;display: block;
                    margin-bottom: 0%;top: 40%;left: 50%;position: absolute;"></div> 
                <div *ngIf="visitCreated" class="alert alert-success alert-dismissible fade show row offset-lg-8 col-lg-4" 
                    role="alert" id="alert-success" style="display: table-cell;
                    background-image: linear-gradient(135deg, #6effc05c 0, #6cadb65c 100%) !important;">
                    <strong style="color: #1e6987;">La visite est créée avec succès</strong> 
                    <button type="button" class="close p-2" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div *ngIf="visitNotCreated" class="alert alert-dismissible fade show row offset-lg-8 col-lg-4" 
                    role="alert" id="alert-failed" style="display: table-cell;
                    background-image: linear-gradient(135deg, #ff6e6e5c 0, #b66c975c 100%) !important;">
                    <strong style="color: #144e64;">La visite n'est pas créée suite à un soucis, réessayer ultérieurement !</strong> 
                    <button type="button" class="close p-2" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-footer md-button" style="justify-content: center;">
                <button type="button" class="btn btn-dark btn-rounded mt-3 mb-2" data-dismiss="modal">Retour</button>
                <button type="button" class="btn btn-gradient-success btn-rounded mt-3 mb-2 btn-rounded" 
                    [disabled]="newVisitForm.invalid || actionsSelected.length==0"
                    (click)="createVisit()">Créer la visite
                </button>
            </div>
        </div>
    </div>
</div>